import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  booleanFormatter,
  buttonsStyle,
  checkboxFormatter,
  dateFormatter,
} from "../../../components/tables/table";
import {
  changeStatusModalidad,
  getModalidades,
} from "../../../../api/modalidad";
import { Button, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import { getNonEmpty } from "../../../../utils/helpers";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";

function getData(modalidades) {
  let data = [];
  for (let i = 0; i < modalidades.length; ++i) {
    const elem = {};
    elem.title = getNonEmpty(modalidades[i].title);
    elem.caserKey = modalidades[i].caserKey;
    elem.generaliKey = modalidades[i].generaliKey;
    elem.zurichKey = modalidades[i].zurichKey;
    elem.createdAt = modalidades[i].createdAt;
    elem.active = modalidades[i].active;
    elem.id = modalidades[i]._id;
    data = data.concat(elem);
  }
  return data;
}

export default function ModalidadesPage() {
  const [data, setData] = useState([]);
  const [modalidadId, setModalidadId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const history = useHistory();

  function buttonFormatter(cell) {
    const elem = data.find((item) => item.id === cell);
    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-modalidad/" + cell)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        <Tooltip title={elem?.active ? "Desactivar" : "Activar"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setModalidadId(elem);
              setOpenConfirmDialog(1);
            }}
          >
            {elem?.active ? (
              <ToggleOffIcon />
            ) : (
              <ToggleOnIcon style={{ color: "red" }} />
            )}
          </Button>
        </Tooltip>
      </>
    );
  }

  const columns = [
    { dataField: "title", text: "Title", sort: true },
    { dataField: "caserKey", text: "Caser", sort: true },
    { dataField: "generaliKey", text: "Generali", sort: true },
    { dataField: "zurichKey", text: "Zurich", sort: true },
    {
      dataField: "createdAt",
      text: "Created at",
      formatter: dateFormatter,
      sort: true,
    },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];
  const defaultSorted = [
    {
      dataField: "title",
      order: "desc",
    },
  ];

  useEffect(() => {
    getModalidades()
      .then((res) => {
        if (res.status === 200) {
          setData(getData(res.data));
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get modalidades.",
        });
      });
  }, [refresh]);

  return (
    <>
      <Card>
        <CardHeader title="Modalidades list"></CardHeader>
        <CardBody>
          <Table data={data} columns={columns} defaultSorted={defaultSorted} />
          <ConfirmDialog
            title={`¿Estás seguro de que quieres ${
              modalidadId?.active ? "desactivar" : "activar"
            } esta modalidad?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusModalidad(modalidadId.id, !modalidadId?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${
                        modalidadId?.active ? "¡Desactivada!" : "¡Activada!"
                      }`,
                      customMessage: `Modalidad ${
                        modalidadId?.active ? "desactivada" : "activada"
                      } correctamente`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `No se ha podido ${
                      modalidadId?.active ? "desactivar" : "activar"
                    } esta pais.`,
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
